var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mb-3",attrs:{"small":"","block":"","dark":"","color":"#25d366"},on:{"click":_vm.sendWhatsapp}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-whatsapp")]),_vm._v("Enviar Via Whatsapp ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }